import { render, staticRenderFns } from "./SellingGoods.vue?vue&type=template&id=cf616448&scoped=true&"
import script from "./SellingGoods.vue?vue&type=script&lang=js&"
export * from "./SellingGoods.vue?vue&type=script&lang=js&"
import style0 from "./SellingGoods.vue?vue&type=style&index=0&id=cf616448&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf616448",
  null
  
)

export default component.exports